import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

import { withBase } from '../config/api'
import { primaryButtonStyle } from '../styles/buttonStyles'
import {
  footerModalActionsStyle,
  footerModalBoxStyle,
  footerModalOverlayStyle,
  footerModalTitleStyle
} from '../styles/footerModalStyles'

const COMPANY_FALLBACK = {
  name: 'EnerqiQ Net OÜ',
  address: 'Sepapaja tn 6',
  city: 'Tallinn',
  zip: '11415',
  country: 'Estonia',
  ico: '17553401',
  registration: 'Estonian Commercial Register',
  support_email: 'support@enerqiq.net',
  info_email: 'support@enerqiq.net',
  phone: ''
}

const GDPRModal = ({ open, onClose, openedFrom }) => {
  const { t } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)
  const [company, setCompany] = useState(COMPANY_FALLBACK)

  useEffect(() => {
    if (!open) return

    const controller = new AbortController()

    const loadCompany = async () => {
      try {
        const response = await fetch(withBase('/company/about'), {
          signal: controller.signal
        })

        if (!response.ok) {
          throw new Error('company-load-failed')
        }

        const data = await response.json()

        const validCompanyData = Object.fromEntries(
          Object.entries(data || {}).filter(([, value]) => {
            return (
              value !== null &&
              value !== undefined &&
              String(value).trim() !== ''
            )
          })
        )

        setCompany({
          ...COMPANY_FALLBACK,
          ...validCompanyData
        })
      } catch (error) {
        if (error.name !== 'AbortError') {
          setCompany(COMPANY_FALLBACK)
        }
      }
    }

    loadCompany()

    const handleKeyDown = event => {
      if (event.key !== 'Escape') return
      if (openedFrom === 'checkbox') return

      onClose()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      controller.abort()
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose, openedFrom])

  if (!open) return null

  const gdpr = {
    GDPR_TITLE: t('GDPR_TITLE'),
    GDPR_TEXT: t('GDPR_TEXT')
  }

  const countryValue = String(company.country || '').trim()

  const countryName = /^[A-Z]{2}$/.test(countryValue)
    ? t(countryValue, {
        defaultValue: countryValue
      })
    : countryValue

  const companyAddress = [
    company.address,
    [company.zip, company.city].filter(Boolean).join(' '),
    countryName
  ]
    .filter(Boolean)
    .join(', ')

  const replaceCompanyVariables = text => {
    if (typeof text !== 'string') return ''

    const values = {
      COMPANY_NAME: company.name,
      COMPANY_ADDRESS: companyAddress,
      COMPANY_ICO: company.ico,
      COMPANY_REGISTRATION: company.registration,
      COMPANY_SUPPORT_EMAIL: company.support_email,
      COMPANY_INFO_EMAIL: company.info_email,
      COMPANY_PHONE: company.phone
    }

    return Object.entries(values).reduce(
      (result, [key, value]) =>
        result.replaceAll(`{{${key}}}`, value || ''),
      text
    )
  }

  return (
    <>
      <div
        onClick={() => {
          if (openedFrom === 'checkbox') return
          onClose()
        }}
        style={footerModalOverlayStyle()}
      />

      <div style={footerModalBoxStyle()}>
        <div style={footerModalTitleStyle()}>
          {replaceCompanyVariables(gdpr.GDPR_TITLE)}
        </div>

        <div
          style={{
            whiteSpace: 'pre-line',
            fontSize: 16
          }}
        >
          {replaceCompanyVariables(gdpr.GDPR_TEXT)}
        </div>

        <div style={footerModalActionsStyle}>
          <button
            onClick={onClose}
            style={primaryButtonStyle(
              pressedBtn,
              'gdpr-close',
              hoverBtn === 'gdpr-close'
            )}
            onMouseEnter={() => setHoverBtn('gdpr-close')}
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() => setPressedBtn('gdpr-close')}
            onMouseUp={() => setPressedBtn(null)}
          >
            {openedFrom === 'checkbox' ? t('AGREE_GDPR') : t('CLOSE')}
          </button>
        </div>
      </div>
    </>
  )
}

export default GDPRModal